<div class="ajax-loading ajax-popup-loading"><div class="loading-icon"></div></div>
<div class="mat-dialog-title" mat-dialog-title="">
    <h2>{{user.id != null && user.id.length > 0 ? "Edit User" : "Add User"}}</h2>
    <button mat-button mat-dialog-close class="close">Cancel</button>
</div>
<form (ngSubmit)="saveUser()">
    <div mat-dialog-content class="example-container">
        <div class="row">
            <!-- <div class="col-md-6" *ngIf="isPasswordVisible">
                <div class="form-group">
                    <mat-label>Password <span class="required">*</span></mat-label>
                    <mat-form-field>
                        <input matInput type="password" maxlength="50" placeholder="Password"
                                [formControl]="password" name="password" [(ngModel)]="user.password" />
                        <mat-error *ngIf="password.invalid">Password is required</mat-error>
                    </mat-form-field>
                </div>
            </div> -->
            <div class="col-md-6">
                <div class="form-group">
                    <mat-label>First Name <span class="required">*</span></mat-label>
                    <mat-form-field>
                        <input matInput type="text" maxlength="100" placeholder="First Name"
                                [formControl]="firstName" name="firstName" [(ngModel)]="user.firstName" />
                        <mat-error *ngIf="firstName.invalid">First Name is required</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <mat-label>Last Name <span class="required">*</span></mat-label>
                    <mat-form-field>
                        <input matInput type="text" maxlength="100" placeholder="Last Name"
                                [formControl]="lastName" name="lastName" [(ngModel)]="user.lastName" />
                        <mat-error *ngIf="lastName.invalid">Last Name is required</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <mat-label>Email <span class="required">*</span></mat-label>
                    <mat-form-field>
                        <input matInput type="text" maxlength="100" placeholder="Email"
                                [formControl]="email" name="email" [(ngModel)]="user.email" />
                        <mat-error *ngIf="email.errors?.['required']">Email is required</mat-error>
                        <mat-error *ngIf="email.errors?.['email']">Invalid Email</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <mat-label>Role <span class="required">*</span></mat-label>
                    <mat-form-field>
                        <mat-select [formControl]="role" [(ngModel)]="selectedRole" placeholder="Select a role">
                            <mat-option [disabled]="roleObj.name.toLowerCase()==='owner'" *ngFor="let roleObj of roleList" [value]="roleObj.id">{{ roleObj.name }}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="role.invalid">Role is required</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    
                </div>
            </div>
        </div>
    </div>
    <div mat-dialog-actions class="row">
        <div class="col-12">
            <div class="text-center py-3 d-flex  justify-content-center"> 
                <button mat-raised-button color="primary" (click)="closeDialog()" type="button" class="btn-outline-black me-3">Cancel </button>
                <button mat-raised-button color="primary" type="submit" class=" btn-black ">Save </button>&nbsp;&nbsp;                
            </div>
        </div>
    </div>
</form>
